import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "../index.css"

import { Dialog } from "primereact/dialog";
import { Button } from "../../../helpers";

import ApproveVendorPaymentModal from "./ApproveVendorPaymentModal";
import RejectVendorPaymentModal from "./RejectVendorPaymentModal";

import { approveVendorPaymentsStatus, rejectVendorPaymentsStatus } from "../../../services/api/vendorPayment";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import useTranslationWithLoading from "../../../common/hooks/useTranslationWIthLoading";
import { getFullName } from "../../../utils";
import { DATE_FORMAT } from "../../../constants";


const paymentTermLabelMap = {
	payAdvPO: "Advance Against PO",
	payAdvDelivery: "Advance before Delivery",
	payPDCDelivery: "PDC on Delivery",
	payOnDelivery: "On Delivery",
	payCredit: "Credit"
}

const PaymentHistory = (props) => {
	const { t } = useTranslationWithLoading('VendorPaymentSummary/index')

    const {vendorPayments, setVendorPayments, sellerPIPunch, statusList, getSellerPO, setIsLoading, viewFlag, approvalInstances, approvals} = props

	const [visibleVPApprove, setVisibleVPApprove] = useState(false)
	const [visibleVPReject, setVisibleVPReject] = useState(false)
	const [selectedVendorPayment, setSelectedVendorPayment] = useState()
	const usersData = useSelector(state => state.userDetails)
	const companyUsers = usersData?.PMCompanyDetails.companyUsers

	
	const dispatch = useDispatch()

	const handleApproveVendorPayment = async (isAlreadyIncludedProfit) => {
		const data = {
			statusId : 9,
			processedBy : usersData?.userId,
			processedAt : new Date()
		}
		if(isAlreadyIncludedProfit){
			data.isAlreadyIncludedProfit = true
		}

		setIsLoading(true)

		const response = await approveVendorPaymentsStatus(selectedVendorPayment, data)
		console.log("approveVendorPaymentsStatus", response, selectedVendorPayment)
		if (response.failure){
			dispatch(raiseToast({severity:'error', detail: response.data.error, life: 3000}))
			setIsLoading(false)
		}else {
			dispatch(raiseToast({severity:'success', detail: "Payments Approved Successfully", life: 3000}))
			const updatedVendorPayments = vendorPayments.map(eachVendorPayment => {
				if(eachVendorPayment.vendorPaymentId === selectedVendorPayment){
					eachVendorPayment.statusId = 9
					eachVendorPayment.approvedOrRejectedAt = new Date()
					if(eachVendorPayment.paymentMode === "CASH"){
						eachVendorPayment.statusId = 10
						eachVendorPayment.processedAt = new Date()
					}
				}
				return eachVendorPayment
			})
			setVendorPayments(updatedVendorPayments)
			setVisibleVPApprove(false)
			setIsLoading(false)
		}
	}

	const handleRejectVendorPayment = async (rejectRemarks) => {
		const data = {
			statusId: 8,
			processedBy: usersData?.userId,
			processedAt: new Date()
		}
		if(rejectRemarks){
			data.rejectedRemarks = rejectRemarks
		}

		setIsLoading(true)

		const response = await rejectVendorPaymentsStatus(selectedVendorPayment, data)
		if (response.failure){
			dispatch(raiseToast({severity:'error', summary: 'Error', detail: "Payment has not Rejected", life: 3000}))
			setIsLoading(false)
		}else {
			dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payment Rejected Successfully", life: 3000}))
			setVisibleVPReject(false)
			getSellerPO()
		}

		setIsLoading(false)
	}

    const renderPaymentHistoryRows = (vendorPayment) => {
        let paymentDate = ''
        if (vendorPayment.paymentDate) {
            paymentDate = moment(vendorPayment.paymentDate).format(DATE_FORMAT)
        }

        let statusObj = statusList?.find(eachStatus => eachStatus.statusId === vendorPayment.statusId)
		
		let approvedOrRejectedByUser = companyUsers.find(eachUser => eachUser.userId === vendorPayment.approvedOrRejectedBy)
		let approvedOrRejectedByUserName = approvedOrRejectedByUser?.firstName 
		if(approvedOrRejectedByUser?.lastName){
			approvedOrRejectedByUserName += " " + approvedOrRejectedByUser.lastName
		}

		let createdByUser = companyUsers.find(eachUser => eachUser.userId === vendorPayment.createdBy)
		let createdByUserName = createdByUser?.firstName 
		if(createdByUser?.lastName){
			createdByUserName += " " + createdByUser.lastName
		}

		let relatedSellerPIPunch = sellerPIPunch?.find(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId === vendorPayment.sellerPIPunchId)

		let remarks = vendorPayment.remarks
		if(vendorPayment.rejectedRemarks){
			remarks = vendorPayment.rejectedRemarks
		}
		if(vendorPayment.processedRemarks){
			remarks = vendorPayment.processedRemarks
		}
		if(vendorPayment.UTR){
			remarks = vendorPayment.UTR
		}

		let approverUser = null
		let approverName = ""

		if(approvals?.length){
			const relatedPOAmtApprovalIds = approvals.filter(eachApproval => [17, 21].includes(eachApproval.approvalTypeId)).map(eachApproval => eachApproval.approvalId) // APPROVAL_CHANGE find by typeId
			const relatedPOAmtApprovalInstance = approvalInstances.find(eachApprovalInstance => relatedPOAmtApprovalIds.includes(eachApprovalInstance.approvalId) && eachApprovalInstance.statusId === 9)

			approverUser = companyUsers.find(user => user.userId === relatedPOAmtApprovalInstance?.processedBy)
			approverName = approverUser ? getFullName(approverUser.firstName, approverUser.lastName) : ''
		}

		let statusUpdatedBy = ""
		if([8, 9].includes(vendorPayment.statusId)){
			if(vendorPayment.approvedOrRejectedBy === 18766){
				statusUpdatedBy = approverName
			} else {
				statusUpdatedBy = approvedOrRejectedByUserName
			}
		}

		let statusColor = "black"
		if([10, 9].includes(vendorPayment.statusId)){
			statusColor = "green"
		} else if([8, 11, 6].includes(vendorPayment.statusId)){
			statusColor = "red"
		}

		let statusBGColor = "white"
		if([10, 9].includes(vendorPayment.statusId)){
			statusBGColor = "rgb(83 166 83 / 8%)"
		} else if([8, 11, 6].includes(vendorPayment.statusId)){
			statusBGColor = "#f2abab29"
		}

		return(
			<tr style={{backgroundColor: statusBGColor}}>
				<td className="custom-td">
					<b style={{margin:0}}>{vendorPayment.docNo}</b>
					<p style={{margin:0}}>{moment(vendorPayment.createdAt).format(DATE_FORMAT)}</p>
					<p style={{margin:0}}>{createdByUserName}</p>
				</td>
				<td className="custom-td">{ vendorPayment.amount }</td>
				<td className="custom-td">{ vendorPayment.tdsAmount }</td>
				<td className="custom-td">{ vendorPayment.tcsAmount }</td>
				<td className="custom-td">{ vendorPayment.paymentMode }</td>
				<td className="custom-td">{ paymentDate }</td>
				<td className="custom-td">
					<div>
						<p style={{margin:0}}>{ paymentTermLabelMap[vendorPayment.paymentTerm] }</p>
						{ vendorPayment.sellerPIPunchId ?
							<p style={{margin: 0, marginTop: 1, fontWeight: 'bold'}}>{relatedSellerPIPunch?.sellerPINumber ? relatedSellerPIPunch.sellerPINumber : ""}</p> 
							: ""
						}
						{/*<p style={{margin:0}}>{ vendorPayment.remarks }</p>*/}
					</div>
				</td>
				<td className="custom-td">
					<p style={{margin:0, fontSize: "12px", color: statusColor}}>{statusObj?.status}</p>
					{/*
						statusObj?.status == 'APPROVED' && vendorPayment.paymentTerm == 'payCredit' ? <p style={{margin:0, color: '#7a2c69'}}>{vendorPayment.isVerifiedByFinance ? "Verified by finance" : "Under finance verification"}</p> : ""
					*/}
					{
					    statusObj?.status !== 'REQUESTED' ?
                            statusObj?.status == "APPROVED" || !statusObj?.status == "PAYMENTDONE" ?
							<>
								{ moment( vendorPayment.approvedOrRejectedAt ).format(DATE_FORMAT)}
							</>
							:
							<>
								{ vendorPayment.processedAt ? moment( vendorPayment.processedAt ).format(DATE_FORMAT) : ""}
							</>
						: " "
					}
                    {
                        vendorPayment.chequeDetails?.chequeRealisedDate ? <> <br/>( { moment(vendorPayment.chequeDetails?.chequeRealisedDate).format(DATE_FORMAT)} ) </> : ""
                    }
				</td>
				<td className="custom-td">{ remarks ? remarks : null }</td>
				
				{ viewFlag ? "" :
					<td className="custom-td">
						{  statusObj?.status === 'REQUESTED' ?
							<div className="flex flex-row justify-content-center"> 
								<Button icon="pi pi-check" className="small-btn" disabled={vendorPayment.createdBy === usersData.userId} onClick={() => { setVisibleVPApprove(true) ; setSelectedVendorPayment(vendorPayment.vendorPaymentId) }} permissions={[54]} permParameters={{amount: vendorPayment.amount}} />
								<Button icon="pi pi-times" className="small-btn ml-2" severity="danger" onClick={() => { setVisibleVPReject(true) ; setSelectedVendorPayment(vendorPayment.vendorPaymentId)}} permissions={[54]} />
							</div>
							:
							statusObj?.status
						}
						<br />
						{ 
							statusUpdatedBy && <span> by {statusUpdatedBy}</span>
						}
					</td>
				}
			</tr>
		)
    }
    
    return (
        <div className={viewFlag ? `` : `p-card payment-history-table-container`}>
            <table className="custom-table mb-0 payment-history-table">
                <thead style={{ fontSize: "12px" }}>
                    <tr className="custom-table-tr custom-tr" style={{backgroundColor: "#f3f3f378"}}>
                        <th className="custom-th">Payment No</th>
                        <th className="custom-th">Amount</th>
                        <th className="custom-th">TDS</th>
                        <th className="custom-th">TCS</th>
                        <th className="custom-th">Mode</th>
                        <th className="custom-th">Payment Date</th>
                        <th className="custom-th">Note</th>
                        <th className="custom-th">Status</th>
                        <th className="custom-th">Remarks</th>
                        {viewFlag ? "" : <th className="custom-th">Approve/Reject</th>}
                    </tr>
                </thead>
                {
                    vendorPayments.length == 0 ? <p> Vendor Payments Not Found </p> : 
                        <tbody>
                            { 
                                vendorPayments.map(vp => {
                                    return renderPaymentHistoryRows(vp)
                                })
                            }
                        </tbody>
                }
            </table>
			<Dialog header="Approve Vendor Payment" className=""  visible={visibleVPApprove} style={{ width: '50vw', height: '25vh', backgroundColor: "#eeeff0" }} onHide={() => setVisibleVPApprove(false)}>
                <ApproveVendorPaymentModal handleApproveVendorPayment={handleApproveVendorPayment} />
            </Dialog>
			<Dialog header="Reject Vendor Payment" className=""  visible={visibleVPReject} style={{ width: '50vw', height: '30vh', backgroundColor: "#eeeff0" }} onHide={() => setVisibleVPReject(false)}>
                <RejectVendorPaymentModal handleRejectVendorPayment={handleRejectVendorPayment}/>
            </Dialog>
        </div>
    )
}

export default PaymentHistory;